export const questionsVersion = '1.0';
const interactiveElements = [
    {
        name: "Campus Design",
        id: "CD",
        questions: [
          {
            type: "multi",
            question: "Which strategies should be used to balance built areas and open space on campus?",
            options: [
              {
                text: "Build fewer, taller new buildings"
              },
              {
                text: "Densify existing buildings"
              },
              {
                text: "Expand campus land resources through strategic land acquisitions"
              },
              {
                text: "Build on existing open spaces"
              },
              {
                text: "Other"
              }
            ],
            other: true
          }
        ]
    },
    {
        name: "Life on Campus",
        id: "LC",
        questions: [
          {
            type: "multi",
            question: "What methods would best celebrate and enhance diversity and community on campus?",
            options: [
              {
                text: "More public art"
              },
              {
                text: "New/changed building names"
              },
              {
                text: "More dedicated spaces for identity groups for faculty, staff, and students"
              },
              {
                text: "More intersectional spaces where all campus communities can gather"
              },
              {
                text: "More art/performance spaces"
              },
              {
                text: "Increased variety of architectural styles"
              },
              {
                text: "More transparent walls and windows into campus buildings"
              },
              {
                text: "More welcoming entry points into campus"
              },
              {
                text: "Other"
              }
            ],
            limit: 3,
            other: true
          }
        ]
    },
    {
        name: "Academics",
        id: "AC",
        questions: [
          {
            type: "multi",
            id: "AC-student",
            question: "Where would you like to see more study space on campus?",
            audience: ['ug', 'grad', 'other', 'NO_SELECTION'],
            options: [
              {
                text: "In classroom buildings"
              },
              {
                text: "In libraries"
              },
              {
                text: "In residence halls"
              },
              {
                text: "On the Campus Park"
              },
              {
                text: "Outside the Campus Park"
              }
            ],
            other: false
          },
          {
            type: "multi",
            id: "AC-faculty",
            question: "Where should classroom buildings be located?",
            audience: ['faculty', 'retiree'],
            options: [
              {
                text: "Campus Park – Northeast quadrant (e.g. near Stanley, Evans, Pimentel)"
              },
              {
                text: "Campus Park – Northwest quadrant (e.g. near Li Ka Shing, Wellman, Tolman)"
              },
              {
                text: "Campus Park – Southeast quadrant (e.g. near Chou, Wurster, Kroeber)"
              },
              {
                text: "Campus Park – Southwest quadrant (e.g. near Edwards Stadium, RSF)"
              },
              {
                text: "Campus Park – Central campus (e.g. near Wheeler, Dwinelle, Moffitt)"
              },
              {
                text: "Outside the Campus Park"
              },
              {
                text: "At the Clark Kerr Campus"
              },
              {
                text: "Other, please specify:"
              }
            ],
            other: true
          },
          {
            type: "multi",
            id: "AC-staff",
            question: "Would you choose to telecommute one day a week if it were an option?",
            audience: ['staff'],
            options: [
              {
                text: "Yes"
              },
              {
                text: "No"
              }
            ],
            limit: 1,
            other: false
          },
          {
            type: "multi",
            question: "What brings you to the campus?",
            id: "AC-alum",
            audience: ['community', 'alum'],
            options: [
              {
                text: "Attend sporting events"
              },
              {
                text: "Continuing education programs"
              },
              {
                text: "Attend events, performances, or lectures"
              },
              {
                text: "Walk around and enjoy open space"
              },
              {
                text: "Indoor recreation facilities (RSF, Golden Bear)"
              },
              {
                text: "Outdoor recreation facilities (fields, track)"
              },
              {
                text: "Recreational swimming (Strawberry Canyon, Spieker, etc)"
              },
              {
                text: "Meetings with someone on campus"
              },
              {
                text: "Go to cafes in and around campus"
              },
              {
                text: "Other, please specify:"
              }
            ],
            other: true
          },
        ]
    },
    {
        name: "Getting Around",
        id: "GA",
        questions: [
          {
            type: "multi",
            question: "Which of these methods should be used to help reduce commute-related carbon emissions?",
            options: [
              {
                text: "Bike rental options"
              },
              {
                text: "Improved pedestrian connections to and from the Campus Park"
              },
              {
                text: "Increased rideshare or carpool opportunities"
              },
              {
                text: "Subsidized transit passes"
              },
              {
                text: "Increased AC Transit service"
              },
              {
                text: "Increased opportunities for telecommuting"
              },
              {
                text: "Increased housing supply proximate to campus"
              },
              {
                text: "Increased housing supply proximate to transit"
              },
              {
                text: "More electric vehicle parking"
              },
              {
                text: "Other"
              }
            ],
            other: true
          }
        ]
    },
    {
        name: "EnergyWaterClimate",
        id: "EWC",
        questions: [
          {
            type: "multi",
            question: "What are the top infrastructure concerns that should be addressed in the Long Range Development Plan and Campus Master Plan?",
            options: [
              {
                text: "Seismic safety"
              },
              {
                text: "Power shutoffs"
              },
              {
                text: "Hot days / Heatwaves"
              },
              {
                text: "Flash flooding"
              },
              {
                text: "Ventilation / air quality"
              },
              {
                text: "Reducing energy consumption"
              },
              {
                text: "Renewable energy"
              },
              {
                text: "Green approaches to stormwater management"
              },
              {
                text: "Deferred maintenance of campus systems"
              },
              {
                text: "Reducing potable water consumption"
              }
            ],
            limit: 3,
            other: false
          }
        ]
    },
    {
        name: "AboutYou",
        id: "AboutYou",
        questions: [
          {
            type: "radio",
            id: "AboutYou-ug",
            question: "What is your class year?",
            audience: ['ug', 'NO_SELECTION'],
            options: [
              {
                text: 'Freshman'
              },
              {
                text: 'Sophomore'
              },
              {
                text: 'Junior'
              },
              {
                text: 'Senior or later'
              }
            ],
            other: false
          },
          {
            type: "radio",
            id: "AboutYou-grad",
            question: "How long have you attended UC Berkeley as a graduate student?",
            audience: ['grad'],
            options: [
              {
                text: 'Less than a year'
              },
              {
                text: '1-2 years'
              },
              {
                text: '3-5 years'
              },
              {
                text: '6+ years'
              }
            ],
            other: false
          },
          {
            type: "radio",
            id: "AboutYou-staff",
            question: "How long have you worked at UC Berkeley?",
            audience: ['staff'],
            options: [
              {
                text: 'Less than a year'
              },
              {
                text: '1-5 years'
              },
              {
                text: '6-10 years'
              },
              {
                text: '11-20 years'
              },
              {
                text: '21+ years'
              }
            ],
            other: false
          },
          {
            type: "dropdown",
            id: "AboutYou-prim-coll",
            question: "What is your primary college or school?",
            audience: ['grad', 'faculty', 'retiree'],
            options: [
              {
                text: 'College of Chemistry'
              },
              {
                text: 'College of Education'
              },
              {
                text: 'College of Engineering'
              },
              {
                text: 'College of Environmental Design'
              },
              {
                text: 'Haas School of Business'
              },
              {
                text: 'School of Information'
              },
              {
                text: 'Graduate School of Journalism'
              },
              {
                text: 'Berkeley Law'
              },
              {
                text: 'College of Letters & Science'
              },
              {
                text: 'College of Natural Resources'
              },
              {
                text: 'School of Optometry'
              },
              {
                text: 'School of Public Health'
              },
              {
                text: 'Goldman School of Public Policy'
              },
              {
                text: 'School of Social Welfare'
              },
              {
                text: 'Centers or Institutes'
              },
              {
                text: 'Other'
              }
            ],
            other: true
          },
          {
            type: "radio",
            id: "AboutYou-comm-live",
            question: "Do you live in the City of Berkeley?",
            audience: ['community'],
            options: [
              {
                text: 'Yes'
              },
              {
                text: 'No'
              }
            ],
            other: false
          },
          {
            type: "text",
            id: "AboutYou-staff-dept",
            question: "What is your primary department or affiliation?",
            audience: ['staff'],
            other: false
          },
          {
            type: "radio",
            id: "AboutYou-again",
            question: "Would you be interested in this type of virtual engagement again?",
            options: [
              {
                text: 'Yes'
              },
              {
                text: 'No'
              },
              {
                text: 'Not Sure'
              }
            ],
            other: false
          },
          {
            type: "dropdown",
            id: "AboutYou-alum-grad",
            question: "What year did you graduate?",
            audience: ['alum'],
            options: [
              {
                text: '2020'
              },
              {
                text: '2019'
              },
              {
                text: '2018'
              },
              {
                text: '2017'
              },
              {
                text: '2016'
              },
              {
                text: '2015'
              },
              {
                text: '2014'
              },
              {
                text: '2013'
              },
              {
                text: '2012'
              },
              {
                text: '2011'
              },
              {
                text: '2010'
              },
              {
                text: '2009'
              },
              {
                text: '2008'
              },
              {
                text: '2007'
              },
              {
                text: '2006'
              },
              {
                text: '2005'
              },
              {
                text: '2004'
              },
              {
                text: '2003'
              },
              {
                text: '2002'
              },
              {
                text: '2001'
              },
              {
                text: '2000'
              },
              {
                text: '1999'
              },
              {
                text: '1998'
              },
              {
                text: '1997'
              },
              {
                text: '1996'
              },
              {
                text: '1995'
              },
              {
                text: '1994'
              },
              {
                text: '1993'
              },
              {
                text: '1992'
              },
              {
                text: '1991'
              },
              {
                text: '1990'
              },
              {
                text: '1989'
              },
              {
                text: '1988'
              },
              {
                text: '1987'
              },
              {
                text: '1986'
              },
              {
                text: '1985'
              },
              {
                text: '1984'
              },
              {
                text: '1983'
              },
              {
                text: '1982'
              },
              {
                text: '1981'
              },
              {
                text: '1980'
              },
              {
                text: '1979'
              },
              {
                text: '1978'
              },
              {
                text: '1977'
              },
              {
                text: '1976'
              },
              {
                text: '1975'
              },
              {
                text: '1974'
              },
              {
                text: '1973'
              },
              {
                text: '1972'
              },
              {
                text: '1971'
              },
              {
                text: '1970'
              },
              {
                text: '1969'
              },
              {
                text: '1968'
              },
              {
                text: '1967'
              },
              {
                text: '1966'
              },
              {
                text: '1965'
              },
              {
                text: '1964'
              },
              {
                text: '1963'
              },
              {
                text: '1962'
              },
              {
                text: '1961'
              },
              {
                text: '1960'
              },
              {
                text: '1959'
              },
              {
                text: '1958'
              },
              {
                text: '1957'
              },
              {
                text: '1956'
              },
              {
                text: '1955'
              },
              {
                text: '1954'
              },
              {
                text: '1953'
              },
              {
                text: '1952'
              },
              {
                text: '1951'
              },
              {
                text: '1950'
              },
              {
                text: '1949'
              },
              {
                text: '1948'
              },
              {
                text: '1947'
              },
              {
                text: '1946'
              },
              {
                text: '1945'
              },
              {
                text: '1944'
              },
              {
                text: '1943'
              },
              {
                text: '1942'
              },
              {
                text: '1941'
              },
              {
                text: '1940'
              }
            ],
            other: true
          }
        ]
    }
];

export default interactiveElements;
